import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Card, Col, Container, Row } from "reactstrap";
import AnimatedCrossIcon from "../shared/AnimatedCrossIcon";
import AnimatedCheckIcon from "../shared/AnimatedCheckIcon";
import DOMPurify from "dompurify";

const ERROR_MESSAGE = "An error occurred while processing your payment. Please try again later.";
const SUCCESS_MESSAGE = "Your payment has been successfully processed. Thank you for choosing us.";

const SuccessErrorPage = () => {
  const [isShowError, setIsShowError] = useState(false);

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/error") {
      setIsShowError(true);
    }
  }, []);

  return (
    <Container fluid>
      <Row></Row>
      <Row className="justify-content-center">
        <Col xs="12" md="6">
          <Card body className="p-5">
            {isShowError ? (
              <div className="text-center">
                <AnimatedCrossIcon />
                <h1 className="mt-4 mb-4 error-message">Payment processing error</h1>
                <h5
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(ERROR_MESSAGE) }}
                  style={{ fontSize: "large", color: "#333333" }}
                />
              </div>
            ) : (
              <div className="text-center">
                <AnimatedCheckIcon />
                <h1 className="mt-4 mb-4 success-message">Payment has been processed</h1>
                <h5
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(SUCCESS_MESSAGE) }}
                  style={{ fontSize: "large", color: "#333333" }}
                />
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SuccessErrorPage;
